import React from 'react';
import { TIPTAP_HTML_TYPE } from 'ricos-content';
import { Node_Type, type ToolbarButton } from 'ricos-types';
import { PLUGIN_TOOLBAR_BUTTON_ID } from 'wix-rich-content-editor-common';
import { HeightIcon, selectedNodeResolver, WidthIcon } from 'wix-rich-content-plugin-commons';
import { AlignmentPanel, NodeAlignmentButton } from 'wix-rich-content-toolbars-ui';

import { HTML_BUTTONS } from './consts';
import { TOOLBAR_BUTTON_EDIT_HTML } from './dataHooks';
import { INIT_HEIGHT, INIT_WIDTH, MAX_HEIGHT, MAX_WIDTH, MIN_HEIGHT, MIN_WIDTH } from './defaults';
import { DimensionSliderButton } from './toolbar/DimensionSliderButton';
import { EditHtmlButton } from './toolbar/EditHtmlButton';
import { InsertModal } from './toolbar/insert-modal/InsertModal';
import { SliderModal } from './toolbar/SliderModal';
import type { HtmlPluginEditorConfig } from './types';

const HTML_EDIT_MODAL_ID = `${Node_Type.HTML}.edit`;

export const getToolbarButtons = (config: HtmlPluginEditorConfig, _services): ToolbarButton[] => {
  const {
    minHeight = MIN_HEIGHT,
    maxHeight = MAX_HEIGHT,
    maxWidth = MAX_WIDTH,
    minWidth = MIN_WIDTH,
  } = config || {};
  return [
    {
      id: HTML_BUTTONS.edit,
      dataHook: TOOLBAR_BUTTON_EDIT_HTML,
      modal: {
        Component: InsertModal,
        id: HTML_EDIT_MODAL_ID,
      },
      renderer: toolbarItem => <EditHtmlButton id={HTML_EDIT_MODAL_ID} toolbarItem={toolbarItem} />,
      attributes: {
        selectedNode: selectedNodeResolver,
      },
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
    },
    {
      id: HTML_BUTTONS.width,
      command: ({ data, editorCommands }) => {
        editorCommands.chain().updateAttributes(TIPTAP_HTML_TYPE, data).run();
      },
      modal: {
        Component: SliderModal,
        id: HTML_BUTTONS.width,
      },
      icon: WidthIcon,
      tooltip: 'ChangeDimensions_Width_Tooltip',
      dataHook: 'html_custom_width_slider',
      renderer: toolbarItem => (
        <DimensionSliderButton
          toolbarItem={toolbarItem}
          dimension={'width'}
          min={minWidth}
          max={maxWidth}
          defaultValue={INIT_WIDTH}
        />
      ),
      attributes: {
        selectedNode: selectedNodeResolver,
      },
    },
    {
      id: HTML_BUTTONS.height,
      command: ({ data, editorCommands }) => {
        editorCommands.chain().updateAttributes(TIPTAP_HTML_TYPE, data).run();
      },
      modal: {
        Component: SliderModal,
        id: HTML_BUTTONS.height,
      },
      icon: HeightIcon,
      tooltip: 'ChangeDimensions_Height_Tooltip',
      dataHook: 'html_custom_height_slider',
      renderer: toolbarItem => (
        <DimensionSliderButton
          toolbarItem={toolbarItem}
          dimension={'height'}
          min={minHeight}
          max={maxHeight}
          defaultValue={INIT_HEIGHT}
        />
      ),
      attributes: {
        selectedNode: selectedNodeResolver,
      },
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.ALIGNMENT,
      modal: {
        Component: AlignmentPanel,
        id: HTML_BUTTONS.alignment,
      },
      renderer: toolbarItem => (
        <NodeAlignmentButton toolbarItem={toolbarItem} id={HTML_BUTTONS.alignment} />
      ),
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.DELETE,
    },
  ];
};
